"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shadow_1 = require("./shadow");
const Registry = require("../../registry");
class LeafBlot extends shadow_1.default {
    static value(domNode) {
        return true;
    }
    index(node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    }
    position(index, inclusive) {
        let offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    }
    value() {
        return { [this.statics.blotName]: this.statics.value(this.domNode) || true };
    }
}
LeafBlot.scope = Registry.Scope.INLINE_BLOT;
exports.default = LeafBlot;
